import { render } from "./AcceptanceBillsPageList.vue?vue&type=template&id=bd1aa4d6&scoped=true"
import script from "./AcceptanceBillsPageList.vue?vue&type=script&lang=ts"
export * from "./AcceptanceBillsPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-bd1aa4d6"

export default script